import { isEmpty } from "lodash";
import React, { useMemo } from "react";
import { AssetEsDto } from "types/assetdetails";
import { formatArrayField } from "utils/assetUtils";
import { CellRenderers } from "utils/tableUtils";
import { CopyContent } from "views/Findings/FindingDetails/FindingDetailsSourceInfo";

export const useAssetNetworkResourceFields = (assetDetails: AssetEsDto) => {
  const networkResourceFields = useMemo(() => {
    const fields = [
      {
        label: " Network Resource",
        name: "networkResourceType",
        containerClassName: "flex-column",
        formatter: () =>
          assetDetails.networkResourceProperties.networkResourceType
            ? assetDetails.networkResourceProperties.networkResourceType
            : CellRenderers.VALUE_OR_NA(),
        valueClassName: "break-content",
      },
      {
        label: "Cloud Provider",
        name: "cloudProvider",
        containerClassName: "flex-column",
        formatter: () =>
          assetDetails.cloudProvider
            ? assetDetails.cloudProvider
            : CellRenderers.VALUE_OR_NA(),
      },
      {
        label: "ARN",
        name: "arn",
        containerClassName: "flex-column",
        formatter: () => formatArrayField(assetDetails.arn),
        extra: !isEmpty(assetDetails.arn) ? (
          <CopyContent content={assetDetails.arn.join(", ")} fieldLabel="ARN" />
        ) : null,
      },
    ];
    return fields.map((repositoryField) => ({
      ...repositoryField,
      disabledPin: true,
    }));
  }, [assetDetails]);
  return networkResourceFields;
};
